export default __webpack_public_path__ + "static/media/icon-twitter.8b4702c5.svg";